<template>
  <div class="tooltiper progress-container mr-2" :title="title" v-tooltip>
    <span class="small align-top">{{ label }}</span>
    <div class="progress" style="height: 10px;">
      <div class="progress-bar" role="progressbar" :style="{ 'width': `${percentage}%`, 'background-color': backgroundColor }" :aria-valuenow="percentage" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </div>
</template>

<style lang="scss">
.tooltip-inner {
  white-space: pre-wrap;
}

.progress-container {
  width: 75px;
}

@media (min-width: 992px) {
  .progress-container {
    width: 200px;
  }
}
</style>

<script>
export default {
  name: "ProgressProyecto",
  props: ["title", "label", "percentage", "backgroundColor"]
}
</script>